import React from 'react';
import { Grid } from "@material-ui/core"
import InputVnName from './input/VnName';
import VnVorname from './input/VnVorname';
import VnAnschriftStrasse from './input/VnAnschriftStrasse';
import VnAnschriftPlz from './input/VnAnschriftPlz';
import VnGeburtsdatum from './input/VnGeburtsdatum';
import VnAnschriftOrt from './input/VnAnschriftOrt';
import VnKommEmailPrivat from './input/VnKommEmailPrivat';
import VnKommHandyPrivat from './input/VnKommHandyPrivat';
import VnAnrede from './input/VnAnrede';
import VnTitel from './input/VnTitel';
import VnAnschriftHsnr from './input/VnAnschriftHsnr';


const FormVn: React.FC = () => {
    return (
        <Grid container spacing={4}>

            <Grid item xs={6} md={6}>
                <VnAnrede />
            </Grid>

            <Grid item xs={6} md={6}>
            </Grid>

            <Grid item xs={6} md={6}>
                <VnTitel />
            </Grid>

            <Grid item xs={6} md={6}>
            </Grid>

            <Grid item xs={12} md={6}>
                <VnVorname />
            </Grid>

            <Grid item xs={12} md={6}>
                <InputVnName />
            </Grid>

            <Grid item xs={12} md={6}>
                <VnGeburtsdatum />
            </Grid>

            <Grid item xs={12} md={6}>
            </Grid>

            <Grid item xs={12} md={6}>
                <VnAnschriftStrasse />
            </Grid>

            <Grid item xs={12} md={6}>
                <VnAnschriftHsnr />
            </Grid>

            <Grid item xs={12} md={6}>
                <VnAnschriftPlz />
            </Grid>

            <Grid item xs={12} md={6}>
                <VnAnschriftOrt />
            </Grid>

            <Grid item xs={12} md={12}>
                <VnKommEmailPrivat />
            </Grid>

            <Grid item xs={12} md={12}>
                <VnKommHandyPrivat />
            </Grid>
        </Grid>
    );
}

export default FormVn;